import * as React from 'react';

import Page0 from '@buyside/svgs/userApplicationNavigation/page0.svg';
import Page1 from '@buyside/svgs/userApplicationNavigation/page1.svg';
import Page2 from '@buyside/svgs/userApplicationNavigation/page2.svg';
import Page3 from '@buyside/svgs/userApplicationNavigation/page3.svg';
import { WizardNavTracker } from '@buyside/components/presentation/Form/Wizard/Wizard';

import styles from '@buyside/components/presentation/AccreditedInvestorProfilePage/Pages/pageStyles.scss';

const PageHeader: React.FunctionComponent<{ subHeader?: string }> = ({
  subHeader
}): React.ReactElement => {
  return (
    <div className={styles.pageHeader}>
      <WizardNavTracker>
        {({ page }: { page: number }): React.ReactElement => {
          const components = [Page0, Page1, Page2, Page3];
          const Component = components[page];
          return <Component />;
        }}
      </WizardNavTracker>
      <h3>Accredited Investor Questionnaire</h3>
      {subHeader && <h4>{subHeader}</h4>}
    </div>
  );
};

export default PageHeader;
